import { render, staticRenderFns } from "./CompInformation.vue?vue&type=template&id=47ace7ba"
import script from "./CompInformation.vue?vue&type=script&lang=js"
export * from "./CompInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports